import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService, BaseSiteService } from '@spartacus/core';
import { distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'app-api-failure-dialog',
  standalone: false,
  templateUrl: './api-failure-dialog.component.html',
  styleUrls: ['./api-failure-dialog.component.scss']
})
export class ApiFailureDialogComponent {
  currentSite: string='';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,private baseSiteService:BaseSiteService,private router:Router,private cd:ChangeDetectorRef, private authService:AuthService,public dialogRef: MatDialogRef<ApiFailureDialogComponent>
  ) {}

  ngOnInit(){
    this.baseSiteService.getActive().subscribe(site => {
      this.currentSite =site;
      this.cd.detectChanges();
    });
  }

  close(){
    this.dialogRef.close();
    localStorage.removeItem('FailureDailog');
    this.cd.detectChanges();

    if(this.currentSite == 'seqirusb2b-uk')
    {

      if(!window.location.href.includes('my-account')){
      this.router.navigate(['/my-account']);
      }
      
    }

  }

}
